






import Vue, { PropType } from 'vue';
import Button from '../Button/Button.vue';
import { ButtonTypes, ButtonSizes } from '../Button/Button.types';

export default Vue.extend({
  name: 'text-button',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String as PropType<ButtonTypes>,
    },
    size: {
      type: String as PropType<ButtonSizes>,
    },
    label: {
      type: String,
      required: true,
    },
  },
  components: {
    Button,
  },
});
